module.exports = __webpack_public_path__ + "img/11.6ebf4d38.jpg";